"use client"

import type React from "react"
import { useState, useEffect, useRef } from "react"
import { Box, CircularProgress, Alert, Button } from "@mui/material"
import LoanStatement from "./LoanStatement"
import PrintIcon from "@mui/icons-material/Print"
import DownloadIcon from "@mui/icons-material/Download"
import { PDFDownloadLink } from "@react-pdf/renderer"
import PdfStatement from "./PdfStatement"

interface LoanStatementContainerProps {
  loanNumber?: string
  apiBaseUrl?: string
  statementData?: any
}

const LoanStatementContainer: React.FC<LoanStatementContainerProps> = ({
  loanNumber = "104219000314",
  apiBaseUrl = "http://localhost:8080/api",
  statementData: propStatementData,
}) => {
  const [statementData, setStatementData] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const componentRef = useRef<HTMLDivElement>(null)

  // Sample data matching your provided statement
  const sampleData = {
    borrowerName: "Daniel Bvurire",
    coApplicantName: "",
    address: "9999 Gasa Motors Lundi Business Centre, Chivi, Zimbabwe",
    loanNumber: "104219000314",
    disbursedAmount: 300000,
    termOfLoan: 12,
    termUnit: "Months",
    rateOfInterest: 120,
    emiStartDate: "",
    periodFrom: "01-01-2022",
    periodTo: "29-06-2023",
    transactions: [
      {
        txnDate: "31-01-2022",
        voucher: "JV/8855",
        narration: "Disbursement",
        debit: 300000,
        credit: 0,
        balance: 300000,
      },
      {
        txnDate: "31-01-2022",
        voucher: "JV/8859",
        narration: "Interest Capital",
        debit: 18000,
        credit: 0,
        balance: 318000,
      },
      {
        txnDate: "28-02-2022",
        voucher: "JV/8990",
        narration: "Interest Capital",
        debit: 18000,
        credit: 0,
        balance: 336000,
      },
      {
        txnDate: "31-03-2022",
        voucher: "JV/9047",
        narration: "Being a direct deposit for L/repay for danniel bvurire dated 25.03.2022",
        debit: 0,
        credit: 43000,
        balance: 293000,
      },
      {
        txnDate: "31-03-2022",
        voucher: "JV/9196",

        narration: "daniel bvurire l/rep by swipe dated 31.03.22 rec 025379r",
        debit: 0,
        credit: 43000,
        balance: 250000,
      },
      {
        txnDate: "31-03-2022",
        voucher: "JV/9211",

        narration: "Interest Capital",
        debit: 18000,
        credit: 0,
        balance: 268000,
      },
      {
        txnDate: "30-04-2022",
        voucher: "JV/9372",

        narration: "daniel bvurire l/rep byswipe dated 27.4.22 rec 025436r",
        debit: 0,
        credit: 43000,
        balance: 225000,
      },
      {
        txnDate: "30-04-2022",
        voucher: "JV/9406",

        narration: "Interest Capital",
        debit: 18000,
        credit: 0,
        balance: 243000,
      },
      {
        txnDate: "31-05-2022",
        voucher: "JV/9560",

        narration: "daniel bvurire l/rep by swipe dated 31.05.22 rec 025513r 929400 & 13600)",
        debit: 0,
        credit: 43000,
        balance: 200000,
      },
      {
        txnDate: "31-05-2022",
        voucher: "JV/9580",

        narration: "Interest Capital",
        debit: 18000,
        credit: 0,
        balance: 218000,
      },
      {
        txnDate: "30-06-2022",
        voucher: "JV/9732",

        narration: "danniel bvurire l/rep by swipe dated 27.06.22 rec 025598r",
        debit: 0,
        credit: 43000,
        balance: 175000,
      },
      {
        txnDate: "30-06-2022",
        voucher: "JV/9772",

        narration: "Interest Capital",
        debit: 18000,
        credit: 0,
        balance: 193000,
      },
      {
        txnDate: "29-07-2022",
        voucher: "JV/9910",

        narration: "danniel bvurire l/rep by swipe dated 28.07.22 rec 027691r",
        debit: 0,
        credit: 46000,
        balance: 147000,
      },
      {
        txnDate: "31-07-2022",
        voucher: "JV/9931",

        narration: "Interest Capital",
        debit: 51000,
        credit: 0,
        balance: 198000,
      },
      {
        txnDate: "30-08-2022",
        voucher: "JV/10128",

        narration: "danniel bvurire l/rep by swipe dated 31.08.22 rec 027781r",
        debit: 0,
        credit: 106000,
        balance: 92000,
      },
      {
        txnDate: "31-08-2022",
        voucher: "JV/10144",

        narration: "Interest Capital",
        debit: 51000,
        credit: 0,
        balance: 143000,
      },
      {
        txnDate: "30-09-2022",
        voucher: "JV/10287",

        narration: "Interest Capital",
        debit: 51000,
        credit: 0,
        balance: 194000,
      },
      {
        txnDate: "31-10-2022",
        voucher: "JV/10488",

        narration: "Interest Capital",
        debit: 51000,
        credit: 0,
        balance: 245000,
      },
      {
        txnDate: "24-11-2022",
        voucher: "JV/10544",

        narration: "Being a direct deposit for L/repay for daniel bvurire dated 16.11.2022",
        debit: 0,
        credit: 76000,
        balance: 169000,
      },
      {
        txnDate: "30-11-2022",
        voucher: "JV/10599",

        narration: "Interest Capital",
        debit: 51000,
        credit: 0,
        balance: 220000,
      },
      {
        txnDate: "31-12-2022",
        voucher: "JV/10722",

        narration: "Interest Capital",
        debit: 51000,
        credit: 0,
        balance: 271000,
      },
      {
        txnDate: "31-01-2023",
        voucher: "JV/10846",

        narration: "Interest Capital",
        debit: 51000,
        credit: 0,
        balance: 322000,
      },
      {
        txnDate: "28-02-2023",
        voucher: "JV/10957",

        narration: "Interest Capital",
        debit: 30000,
        credit: 0,
        balance: 352000,
      },
      {
        txnDate: "31-03-2023",
        voucher: "JV/11085",

        narration: "Interest Capital",
        debit: 30000,
        credit: 0,
        balance: 382000,
      },
      {
        txnDate: "29-04-2023",
        voucher: "JV/11112",

        narration: "Being a direct deposit for L/repay for daniel bvurire dated 26.04.2023 REF FT23116VFT6C/TRE",
        debit: 0,
        credit: 228000,
        balance: 154000,
      },
      {
        txnDate: "30-04-2023",
        voucher: "JV/11168",

        narration: "Interest Capital",
        debit: 30000,
        credit: 0,
        balance: 184000,
      },
      {
        txnDate: "30-05-2023",
        voucher: "JV/11305",

        narration: "daniel bvurire l/rep by swipe dated 31.05.23 rec0329046r",
        debit: 0,
        credit: 84000,
        balance: 100000,
      },
      {
        txnDate: "30-05-2023",
        voucher: "JV/11307",

        narration: "daniel bvurire l/rep by swipe dated 31.05.23 rec 029048r",
        debit: 0,
        credit: 133000,
        balance: -33000,
      },
    ],
    roiHistory: [
      {
        sno: 1,
        startDate: "01-01-2022",
        endDate: "31-12-2022",
        roi: "120% PA",
        emiAmount: 43000,
      },
    ],
    pageInfo: {
      currentPage: 1,
      totalPages: 2,
      takenBy: "104/jmakonese100",
      dateTime: "17-07-2023/1:56 PM",
    },
  }

  useEffect(() => {
    const fetchStatementData = async () => {
      try {
        setLoading(true)
        
        // Use prop data if available, otherwise use sample data
        if (propStatementData) {
          setStatementData(propStatementData)
        } else {
          // Fallback to sample data for demo purposes
          setTimeout(() => {
            setStatementData(sampleData)
          }, 1000)
        }
        
        setLoading(false)
      } catch (err) {
        setError("Failed to fetch loan statement data")
        setLoading(false)
        console.error("Error fetching statement:", err)
      }
    }

    fetchStatementData()
  }, [loanNumber, apiBaseUrl, propStatementData])

  const handlePrint = () => {
    window.print()
  }



  if (loading) {
    return (
      <Box className="flex justify-center items-center h-64">
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Box className="p-4">
        <Alert severity="error">{error}</Alert>
      </Box>
    )
  }

  if (!statementData) {
    return (
      <Box className="p-4">
        <Alert severity="info">No statement data available</Alert>
      </Box>
    )
  }

  return (
    <Box>
      {/* Export Actions - Only visible on screen */}
      <Box className="p-3 bg-gray-50 print:hidden flex justify-end">
        <PDFDownloadLink
          document={<PdfStatement data={statementData} />}
          fileName={`Loan_Statement_${loanNumber}.pdf`}
        >
          {({ blob, url, loading, error }) => {
            // Log any errors for debugging
            if (error) {
              console.error('PDF generation error:', error);
            }
            
            return (
              <Button
                variant="outlined"
                startIcon={<DownloadIcon />}
                disabled={loading}
                size="small"
                className="text-blue-600 border-blue-600"
              >
                {loading ? 'Generating PDF...' : error ? 'Error' : 'Export PDF'}
              </Button>
            );
          }}
        </PDFDownloadLink>
        <Button
          variant="outlined"
          startIcon={<PrintIcon />}
          onClick={handlePrint}
          size="small"
          className="text-green-600 border-green-600 ml-2"
        >
          Print
        </Button>
      </Box>

      {/* The visible Loan Statement component */}
      <div ref={componentRef}>
        <LoanStatement data={statementData} />
      </div>
    </Box>
  )
}

export default LoanStatementContainer
